import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import useProjectDefinition from 'src/app/projects/views/new-project-definition/hooks/useProjectDefinition';
import styles from 'src/app/projects/views/new-project-definition/NewProjectDefinition.module.scss';
import { hasHabitatInsightsFeature } from 'src/shared/utils/featureHelpers';
import CompletionBadge from 'src/shared/components/completion-badge/CompletionBadge';
import HabitatInsightsSamples from './components/habitat-insights-samples/HabitatInsightsSamples';
import HabitatInsightsReview from './components/habitat-insights-review/HabitatInsightsReview';
import { getSectionStatus } from '../../helpers/sectionCompletion';

export const HabitatInsights = () => {
    const { formState } = useProjectDefinition();
    const { features, habitatInsightsUploadedFileContent } = formState;
    const status = getSectionStatus(formState, 'habitatInsights');

    if (!hasHabitatInsightsFeature(features || [])) {
        return null;
    }

    return (
        <div className={styles.formView}>
            <div className={styles.formViewTitle}>
                <span>Habitat Insights</span>
                <div className={styles.sectionStatus}>
                    {status.isComplete && <CheckCircle className={styles.completeIcon} />}
                    {status.hasErrors && <AlertCircle className={styles.errorIcon} />}
                    <CompletionBadge completedFields={status.completedFields} totalFields={status.totalFields} />
                </div>
            </div>
            <div className='flex flex-col gap-[25px]'>
                <div className='w-full flex flex-col'>
                    <div className='text-primary text-[17px] mb-[20px]'>Remote sensing - Areas of interest</div>
                    <HabitatInsightsSamples />
                </div>
            </div>
            {habitatInsightsUploadedFileContent && (
                <div className='h-full overflow-auto pb-[50px] mt-10'>
                    <HabitatInsightsReview />
                </div>
            )}
        </div>
    );
};

export default HabitatInsights;
